// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__root-dZL8BQ","rootcenter":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__rootcenter-Zr_kaY","freeBox":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__freeBox-OQ6SRs","freeBoxcenter":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__freeBoxcenter-JT9XYr"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__root-dZL8BQ\",\"rootcenter\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__rootcenter-Zr_kaY\",\"freeBox\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__freeBox-OQ6SRs\",\"freeBoxcenter\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicListSectionSeparator-module__freeBoxcenter-JT9XYr\"}";
        // 1793541990387
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  